/**
 * Household member roles are stored as raw values ("Parent" / "Child" / "Other").
 * The Settings dropdown localizes the *options*, but displaying an existing member's
 * role showed the raw value (#241). This maps a stored role to its i18n key so the
 * UI can render the translated label (de: Elternteil / Kind / Sonstige).
 */
export function memberRoleLabelKey(role: string | undefined | null): string | null {
  switch (role) {
    case 'Parent':
      return 'pages.settings.role_parent';
    case 'Child':
      return 'pages.settings.role_child';
    case 'Other':
      return 'pages.settings.role_other';
    default:
      // Unknown / custom role: no i18n key — caller falls back to the raw value.
      return null;
  }
}
